// === CALCOLO PREZZO SCALARE COPERTINA (pagina prodotto) ===

(function() {
  const PREZZI_TESSUTO    = [0, 28, 25, 23, 23, 23, 20];
  const PREZZI_SIMILPELLE = [0, 20, 18, 15, 15, 15, 13];
  const PREZZI_MORBIDA    = { tessuto: 15, similpelle: 13 };

  function isMorbida() {
    return document.getElementById('rilegatura-select')?.value === 'morbida';
  }

  function getPrezzoScalare(tipo, numCopie, morbida) {
    if (morbida) {
      const prezzoCopia = PREZZI_MORBIDA[tipo] || 13;
      return prezzoCopia * numCopie;
    }
    const lista = tipo === 'tessuto' ? PREZZI_TESSUTO : PREZZI_SIMILPELLE;
    let totale = 0;
    for (let i = 1; i <= numCopie; i++) {
      const idx = i <= 5 ? i : 6;
      totale += lista[idx];
    }
    return totale;
  }

  function aggiornaPrezzo() {
    const container = document.querySelector('.copertina-options');
    if (!container) return;

    const rilegatura = document.getElementById('rilegatura-select')?.value;
    if (!rilegatura) return;

    const tipo    = container.querySelector('[name="properties[_tipo_materiale]"]')
                      ?.value?.trim() || 'similpelle';
    const copie   = parseInt(document.getElementById('copie-input')?.value) || 1;
    const morbida = isMorbida();

    const totCop = getPrezzoScalare(tipo, copie, morbida);
    const el = document.getElementById('prezzo-copertura-val');
    if (el) el.textContent = '€ ' + totCop.toFixed(2).replace('.', ',');

    const nota = document.getElementById('nota-stampa-bn');
    if (nota) {
      const stampa = document.getElementById('stampa-hidden')?.value || '';
      nota.style.display = stampa === 'bianco-nero' ? 'block' : 'none';
    }
  }

  // ── Vincolo parametri dal carrello ───────────────────────────────────────────
  async function applicaVincoloCarrello() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();

      const tipiCopertina = [
        'Copertina Tessuto', 'Copertina Similpelle',
        'Copertina Morbida Tessuto', 'Copertina Morbida Similpelle',
        'Tessuto', 'Similpelle',
      ];

      const copertineNelCarrello = cart.items.filter(item =>
        tipiCopertina.includes(item.product_type)
      );

      if (copertineNelCarrello.length === 0) return;

      const prima      = copertineNelCarrello[0];
      const props      = prima.properties || {};
      const rilegatura = props['_tipo_rilegatura'] || null;
      const grammatura = props['Grammatura Carta'] || props['grammatura'] || null;
      const stampa     = props['Stampa']            || props['stampa']    || null;
      const lati       = props['Lati Stampa']       || props['lati']      || null;

      // ── Pre-compila tipo rilegatura (NON bloccato — cliente può cambiarlo) ───
      if (rilegatura) {
        const rilegSelect = document.getElementById('rilegatura-select');
        if (rilegSelect) rilegSelect.value = rilegatura;
        // Mostra gli altri selettori e evidenzia la descrizione
        window._evidenziaRilegatura?.(rilegatura);
        window._mostraSelettoriAggiuntivi?.();
        aggiornaPrezzo();
      }

      if (!grammatura && !stampa && !lati) return;

      mostraBannerVincolo();

      // ── Blocca grammatura ─────────────────────────────────────────────────────
      const grammaturaSelect = document.getElementById('grammatura-select');
      if (grammaturaSelect && grammatura) {
        grammaturaSelect.value    = grammatura;
        grammaturaSelect.disabled = true;
        grammaturaSelect.title    = 'Parametro bloccato — coerente con le copertine già nel carrello';
        aggiornaPrezzo();
      }

      // ── Blocca stampa (B/N o Colori) ──────────────────────────────────────────
      if (stampa) {
        const stampaVal = stampa.toLowerCase().includes('nero') ? 'bianco-nero' : 'colori';
        const hidden    = document.getElementById('stampa-hidden');
        if (hidden) hidden.value = stampaVal;

        document.querySelectorAll('.stampa-btn[data-stampa]').forEach(btn => {
          const isSelected = btn.dataset.stampa === stampaVal;
          btn.classList.toggle('selected', isSelected);
          btn.style.pointerEvents = 'none';
          btn.style.opacity       = isSelected ? '1' : '0.4';
          btn.title               = 'Parametro bloccato — coerente con le copertine già nel carrello';
        });
        aggiornaPrezzo();
      }

      // ── Blocca lati (Fronte / Fronte-Retro) ───────────────────────────────────
      if (lati) {
        const latiVal = lati.toLowerCase().includes('retro') ? 'fronte-retro' : 'fronte';
        const hidden  = document.getElementById('lati-hidden');
        if (hidden) hidden.value = latiVal;

        document.querySelectorAll('.stampa-btn[data-lati]').forEach(btn => {
          const isSelected = btn.dataset.lati === latiVal;
          btn.classList.toggle('selected', isSelected);
          btn.style.pointerEvents = 'none';
          btn.style.opacity       = isSelected ? '1' : '0.4';
          btn.title               = 'Parametro bloccato — coerente con le copertine già nel carrello';
        });
      }

    } catch (err) {
      console.warn('Impossibile leggere il carrello per il vincolo parametri:', err);
    }
  }

  // ── Banner informativo vincolo ────────────────────────────────────────────────
  function mostraBannerVincolo() {
    if (document.getElementById('banner-vincolo-parametri')) return;

    const container = document.getElementById('selettori-aggiuntivi')
                   || document.querySelector('.copertina-options');
    if (!container) return;

    const banner = document.createElement('div');
    banner.id    = 'banner-vincolo-parametri';
    banner.style.cssText = `
      background: #D6E4F0;
      border: 1px solid #2E86C1;
      border-radius: 8px;
      padding: 12px 16px;
      margin-bottom: 16px;
      font-size: 13px;
      color: #1E3A5F;
      line-height: 1.5;
    `;
    banner.innerHTML = `
      <strong>✋ Ehi, abbiamo già salvato le tue preferenze!</strong><br>
      Per far sì che tutte le tue copie vengano stampate allo stesso modo, abbiamo preimpostato grammatura, modalità di stampa e lati uguali a quelli che hai già scelto. Così non rischi brutte sorprese 😉<br>
      Sei libero di scegliere un colore di copertina diverso, il tipo di rilegatura e il numero di copie che vuoi!
    `;
    container.insertBefore(banner, container.firstChild);
  }

  // ── Colore stampa ─────────────────────────────────────────────────────────────
  document.querySelectorAll('.colore-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.colore-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      const hidden = document.getElementById('colore-stampa-hidden');
      if (hidden) hidden.value = btn.dataset.colore;
    });
  });

  // ── Copie counter ─────────────────────────────────────────────────────────────
  document.getElementById('copie-minus')?.addEventListener('click', () => {
    const inp = document.getElementById('copie-input');
    if (parseInt(inp.value) > 1) { inp.value = parseInt(inp.value) - 1; aggiornaPrezzo(); }
  });
  document.getElementById('copie-plus')?.addEventListener('click', () => {
    const inp = document.getElementById('copie-input');
    inp.value = parseInt(inp.value) + 1; aggiornaPrezzo();
  });
  document.getElementById('copie-input')?.addEventListener('input', aggiornaPrezzo);

  // ── Stampa B/N o Colori ───────────────────────────────────────────────────────
  document.querySelectorAll('.stampa-btn[data-stampa]').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.stampa-btn[data-stampa]')
        .forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      const hidden = document.getElementById('stampa-hidden');
      if (hidden) hidden.value = btn.dataset.stampa;
      aggiornaPrezzo();
    });
  });

  // ── Fronte / Fronte-Retro ─────────────────────────────────────────────────────
  document.querySelectorAll('.stampa-btn[data-lati]').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.stampa-btn[data-lati]')
        .forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      const hidden = document.getElementById('lati-hidden');
      if (hidden) hidden.value = btn.dataset.lati;
    });
  });

  // ── Aggiorna prezzo al cambio grammatura / rilegatura ────────────────────────
  document.getElementById('grammatura-select')?.addEventListener('change', aggiornaPrezzo);
  document.getElementById('rilegatura-select')?.addEventListener('change', aggiornaPrezzo);

  // ── Sincronizza quantità copie con campo nativo Shopify ───────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    const copieInput = document.getElementById('copie-input');
    if (!copieInput) return;

    const sincronizzaQuantita = () => {
      const valore = parseInt(copieInput.value) || 1;
      document.querySelectorAll(
        'input[name="quantity"], .quantity__input, #Quantity, [data-quantity-input]'
      ).forEach(input => {
        if (input !== copieInput) {
          input.value = valore;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    };

    copieInput.addEventListener('change', sincronizzaQuantita);
    copieInput.addEventListener('input',  sincronizzaQuantita);
    document.getElementById('copie-plus')?.addEventListener('click',  () => setTimeout(sincronizzaQuantita, 50));
    document.getElementById('copie-minus')?.addEventListener('click', () => setTimeout(sincronizzaQuantita, 50));
  });

  // ── Intercetta aggiunta al carrello — validazione + proprietà ────────────────
  document.addEventListener('DOMContentLoaded', () => {
    const productForm = document.querySelector('product-form');
    if (!productForm) return;

    productForm.addEventListener('submit', (e) => {
      const rilegatura = document.getElementById('rilegatura-select')?.value;
      const colore     = document.getElementById('colore-stampa-hidden')?.value;
      const grammatura = document.getElementById('grammatura-select')?.value;
      const stampa     = document.getElementById('stampa-hidden')?.value;
      const lati       = document.getElementById('lati-hidden')?.value;
      const tipo       = document.querySelector('[name="properties[_tipo_materiale]"]')?.value || '';
      const copie      = parseInt(document.getElementById('copie-input')?.value) || 1;

      const errori = [];
      if (!rilegatura) errori.push('Tipo di Rilegatura');
      if (!colore)     errori.push('Colore Stampa Copertina');
      if (!grammatura) errori.push('Grammatura Carta');
      if (!stampa)     errori.push('Modalità di Stampa');
      if (!lati)       errori.push('Lati di Stampa');

      if (errori.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert('⚠️ Seleziona i seguenti campi prima di continuare:\n\n• ' + errori.join('\n• '));
        return;
      }

      const form = productForm.querySelector('form');
      if (!form) return;

      const proprieta = {
        'properties[_tipo_rilegatura]': rilegatura,
        'properties[Colore Stampa]':    colore,
        'properties[Grammatura Carta]': grammatura,
        'properties[Stampa]':           stampa,
        'properties[Lati Stampa]':      lati,
        'properties[_tipo_materiale]':  tipo,
        'quantity':                     String(copie),
      };

      Object.entries(proprieta).forEach(([nome, valore]) => {
        let input = form.querySelector(`[name="${nome}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = nome;
          form.appendChild(input);
        }
        input.value = valore;
      });
    }, true);
  });

  // ── Inizializzazione ──────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    aggiornaPrezzo();
    applicaVincoloCarrello();
  });

})();